import Vue from "vue";
import Router from "vue-router";

import Login from "../views/Login.vue";
// import Home from "../views/Home.vue";
import Matrice from "../views/Matrice.vue";
import Preferences from "../views/Preferences.vue";
import ResearchView from "../views/ResearchView.vue";
import Contacts from "../views/Contacts.vue";
import Catalogs from "../views/Catalogs.vue";
// import Catalog from "../views/Catalog.vue";
import CatalogEdit from "../views/CatalogEdit.vue";
import store from "./store";
import axios from "axios";
import config from "../config.js";

Vue.use(Router);

const router = new Router({
	routes: [
		{
			path: "/",
			name: "login",
			component: Login
		},
		{
			path: "/resetpass/:co_id/:challenge",
			name: "resetpass",
			component: Login
		},

		{
			path: "/home",
			name: "home",
			component: Catalogs
		},
		{
			path: "/catalogs",
			name: "catalogs",
			component: Catalogs
		},
		// {
		//   path: "/catalogs/:ca_id",
		//   name: "catalog",
		//   component: Catalog
		// },
		// {
		//   path: "/catalogs/:ca_id/products/:fa_id",
		//   name: "catalogproducts",
		//   component: Catalog
		// },
		// {
		//   path: "/catalogs/:ca_id/products/edit/:pr_id",
		//   name: "catalogproductsedit",
		//   component: Catalog
		// },
		{
			path: "/catalogs/edit/:ca_id",
			name: "catalogedit",
			component: CatalogEdit
		},
		{
			path: "/catalogs/edit/:ca_id/family/edit/:fa_id",
			name: "catalogeditfamily",
			component: CatalogEdit
		},
		{
			path: "/catalogs/edit/:ca_id/products",
			name: "catalogeditproducts",
			component: CatalogEdit
		},
		{
			path: "/catalogs/edit/:ca_id/addproducts",
			name: "catalogeditaddproducts",
			component: CatalogEdit
		},
		/* {
			path: "/catalogs/edit/products/:fa_id",
			name: "catalogeditproducts",
			component: CatalogEdit
		}, */
		{
			path: "/catalogs/edit/:ca_id/products/edit/:pr_id",
			name: "catalogeditproductsedit",
			component: Matrice
		},

		{
			path: "/matrice",
			name: "matrice",
			component: Matrice
		},
		/* {
			path: "/matrice/products/:fa_id",
			name: "matriceproducts",
			component: Matrice
		}, */
		{
			path: "/matrice/products",
			name: "matriceproducts",
			component: Matrice
		},
		{
			path: "/matrice/family/edit/:fa_id",
			name: "matricefamilyedit",
			component: Matrice
		},
		{
			path: "/matrice/products/edit/:pr_id",
			name: "matriceproductsedit",
			component: Matrice
		},

		{
			path: "/contacts",
			name: "contacts",
			component: Contacts
		},

		{
			path: "/contacts/:co_id/details",
			name: "contactdetails",
			component: Contacts
		},
		{
			path: "/contacts/:co_id/edit",
			name: "contactedit",
			component: Contacts,
			meta: { edit: true }
		},
		{
			path: "/preferences",
			name: "preferences",
			component: Preferences
		},

		{
			path: "/research",
			name: "research",
			component: ResearchView,
			props: true
		}
	]
});

router.beforeEach(async (to, from, next) => {
	// console.log("to,from", to, from);
	async function autolog() {
		// console.log("store.state.token", store.state.token);
		if (!store.state.token) return false;
		if (store.state.connected) return true;
		try {
			let response = await axios.post(config.server_url + "/api/1.0/autosignin", {
				token: store.state.token
			});
			if (response.data.err) {
				return false;
			}
			store.commit("set_connexion", {
				token: response.data.token,
				refreshtoken: response.data.refreshtoken,
				user: response.data.data,
				preferences: response.data.preferences
			});
			return true;
		} catch (error) {
			console.error("ko", error);
			return false;
		}
	}

	if (to.name == "resetpass") return next();

	if (to.name != "login" && !store.state.connected) await autolog();
	if (to.name == "login" && store.state.connected) return next({ path: "/home" });
	if (to.name == "login" && !store.state.connected) {
		return next();
	}
	if (!store.state.connected) return next({ path: "/" });

	return next();
});
export default router;
